// extracted by mini-css-extract-plugin
export default {"Input":"Login_Input__g0nrX","Login":"Login_Login__X0tqF","Form":"Login_Form__nWTso"};